import { analyticsCTAUrl, sendDataUrl } from '@anm/analytic/playerAnalytic';
import { useCallback, useEffect, useRef } from 'react';

var useCTAClick = function useCTAClick(projectId, cta) {
  var id = useRef({
    viewId: ''
  });
  var onReceiveMessage = useCallback(function (_ref) {
    var viewId = _ref.data.viewId;
    if (!viewId) return;
    id.current.viewId = viewId;
  }, []);
  useEffect(function () {
    window.addEventListener('message', onReceiveMessage);
    return function () {
      return window.removeEventListener('message', onReceiveMessage);
    };
  }, []);
  var onCTAClick = useCallback(function () {
    sendDataUrl(analyticsCTAUrl)([{
      projectId: projectId,
      type: 'click',
      event: 'action',
      viewId: id.current.viewId,
      meta: {
        ctaLink: cta === null || cta === void 0 ? void 0 : cta.buttonLink,
        ctaText: cta === null || cta === void 0 ? void 0 : cta.buttonText
      }
    }]);
  }, [cta === null || cta === void 0 ? void 0 : cta.buttonLink, cta === null || cta === void 0 ? void 0 : cta.buttonText]);
  return onCTAClick;
};

export default useCTAClick;